import React from "react"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {BusinessApplication, getApplication} from "../../resources/application"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import Assignments from "../Assignments/Assignments"
import {AssignmentResourceType} from "../../resources/assignments"
import {ReceivedPayment} from "../../resources/receivedPayments"
import {Resource} from "../../resources/common"

export interface ReceivedPaymentAssignmentsProps {
	receivedPayment: ReceivedPayment
	included: Resource[]
	businessApplicationId: string | undefined
	accessToken: string
	refreshToken: number
	refresh: () => void
}

export function ReceivedPaymentAssignments({
	receivedPayment,
	included,
	businessApplicationId,
	accessToken,
	refreshToken,
	refresh,
}: ReceivedPaymentAssignmentsProps) {
	if (!businessApplicationId) {
		return (
			<Assignments
				resource={receivedPayment}
				included={included}
				refreshToken={refreshToken}
				refresh={refresh}
				resourceTypes={[AssignmentResourceType.WireReceivedPayment]}
			/>
		)
	}
	const applicationAsyncResultReq = useAsyncResult(
		() => getApplication(accessToken, businessApplicationId),
		[refreshToken]
	)

	return (
		<AsyncResultComponent asyncResult={applicationAsyncResultReq}>
			{(applicationResponse) => {
				const applicationData = applicationResponse.value.data
				const payload = {
					businessApplication: applicationData as BusinessApplication,
				}
				return (
					<Assignments
						resource={receivedPayment}
						included={included}
						payload={payload}
						refreshToken={refreshToken}
						refresh={refresh}
						resourceTypes={[AssignmentResourceType.WireReceivedPayment]}
					/>
				)
			}}
		</AsyncResultComponent>
	)
}
